import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, FormattedNumber} from 'react-intl';

import FiltersSkeleton from '../react-filters-skeleton';
import PricePerTicket from '../react-price-per-ticket';

import './react-pricing-filter.scss';

class PricingFilter extends React.Component {
  constructor(props) {
    super(props);
  }

  get pricePerTicket() {
    let status = '';
    const {
      currency,
      minPrice,
      sliderMin,
      maxPrice,
      sliderMax,
      updateQuery,
      priceWithFees,
      eventPricingSummary,
      eventId,
      averageTicketPrice,
      averageTicketPriceCurrency,
    } = this.props;
    let min = minPrice;
    let max = maxPrice;

    if (minPrice !== sliderMin || maxPrice !== sliderMax) {
      min = (sliderMin && Number.parseFloat(sliderMin).toFixed(2)) || minPrice;
      max = (sliderMax && Number.parseFloat(sliderMax).toFixed(2)) || maxPrice;
      status = (
        <span>
          <FormattedNumber
            style="currency" //eslint-disable-line
            maximumFractionDigits={0}
            minimumFractionDigits={0}
            currencyDisplay="symbol"
            currency={currency}
            useGrouping
            value={min}
          />
          {' - '}
          <FormattedNumber
            style="currency" //eslint-disable-line
            maximumFractionDigits={0}
            minimumFractionDigits={0}
            currencyDisplay="symbol"
            currency={currency}
            useGrouping
            value={max}
          />
        </span>
      );
    }

    return {
      status,
      minPrice,
      maxPrice,
      priceWithFees,
      updateQuery,
      sliderMin,
      sliderMax,
      eventPricingSummary,
      eventId,
      averageTicketPrice,
      averageTicketPriceCurrency,
    };
  }

  render() {
    const {isLoading} = this.props;

    return isLoading ? (
      <FiltersSkeleton />
    ) : (
      <>
        <h3 className="ListingsFilter__sectionContainer__Header">
          <FormattedMessage defaultMessage="Price per ticket" id="ListingsFilter.pricePerTicketHeader" />
        </h3>

        <PricePerTicket {...this.pricePerTicket} />
      </>
    );
  }
}

PricingFilter.propTypes = {
  /** Average ticket price */
  averageTicketPrice: PropTypes.number,

  /** Currency of average ticket price */
  averageTicketPriceCurrency: PropTypes.string,

  /** Price currency */
  currency: PropTypes.string,

  /** Id of event */
  eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Price summary */
  eventPricingSummary: PropTypes.object,

  /** Max price */
  maxPrice: PropTypes.number,

  /** Min price */
  minPrice: PropTypes.number,

  /** Is price with fees? */
  priceWithFees: PropTypes.bool,

  /** Slider max price */
  sliderMax: PropTypes.number,

  /** Slider min price */

  sliderMin: PropTypes.number,
  locale: PropTypes.string,

  /** Is filter loading?*/
  isLoading: PropTypes.bool,
  updateQuery: PropTypes.func,
};

export default PricingFilter;
